export const CHART_COLORS = {
  barBackgroundColor: '#fff',
  backgroundColor: [
    'rgba(98,37,153, 0.2)',
    'rgba(255,51,153, 0.2)',
    'rgba(51,153,255, 0.2)',
    'rgba(221,117,0, 0.2)',
    'rgba(226,61,40, 0.2)',
    'rgba(61,142,51, 0.2)',
    'rgba(170,186,10, 0.2)',
    'rgba(252,209,22, 0.2)',
    'rgba(0,84,160, 0.2)',
    'rgba(153,153,153, 0.2)'
  ],

  borderColor: [
    'rgba(98,37,153, 1)',
    'rgba(255,51,153, 1)',
    'rgba(51,153,255, 1)',
    'rgba(221,117,0, 1)',
    'rgba(226,61,40, 1)',
    'rgba(61,142,51, 1)',
    'rgba(170,186,10, 1)',
    'rgba(252,209,22, 1)',
    'rgba(0,84,160, 1)',
    'rgba(153,153,153, 1)'
  ],

  hoverBackgroundColor: [
    'rgba(98,37,153, 1)',
    'rgba(255,51,153, 1)',
    'rgba(51,153,255, 1)',
    'rgba(221,117,0, 1)',
    'rgba(226,61,40, 1)',
    'rgba(61,142,51, 1)',
    'rgba(170,186,10, 1)',
    'rgba(252,209,22, 1)',
    'rgba(0,84,160, 1)',
    'rgba(153,153,153, 1)'
  ]
};
